import React from 'react';
import { BrowserRouter, Switch, Route} from 'react-router-dom';
import { TransitionGroup, CSSTransition } from "react-transition-group";
import AuthRequired from 'components/authRequired';
import UserLogin from 'containers/userLogin/userLogin';
import SaleConfirm from 'containers/saleConfirm/saleConfirm';
import ConfirmedRecord from 'containers/confirmedRecord/confirmedRecord';

// path rule refer to path-to-regexp@^1.7.0
const Routes = () => {
  return (
    <TransitionGroup>
      <CSSTransition classNames='fade' timeout={300}>
        <BrowserRouter>
          <Switch>
            <Route path='/userLogin' component={UserLogin} />
            <Route path={['/', '/saleConfirm']} exact render={() =>
                <AuthRequired  redirectTo='/saleConfirm' onRender={<SaleConfirm/>} />
              }/>
            <Route path='/confirmedRecord'  render={() =>
                <AuthRequired  redirectTo='/confirmedRecord' onRender={<ConfirmedRecord/>} />
              }/>
          </Switch>
        </BrowserRouter>
      </CSSTransition>
    </TransitionGroup>
  );
};

export default Routes;
